/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AccountingAccountRestService, SystemVarsRestService, TaxRateRestService } from '@gh/builder-shared-data';
import { DictionaryService, InitDialogViewService } from '@gh/common-shared';
import { EmptyDialogInput } from '@gh/core-ui';
import { expandObservable } from '@gh/core-util';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  AccMigrationDetails,
  accMigrationDetailsFromDto,
  accMigrationDetailsToDto,
  accMigrationXeroAccountListFromDto,
} from './model/acc-migration.model';

export interface AccMigrationAccountDialogConfig {
  code?: string;
  name?: string;
}

@Injectable()
export class AccMigrationBusinessService implements InitDialogViewService<EmptyDialogInput> {
  constructor(private dictionaries: DictionaryService,
              private systemVarsRest: SystemVarsRestService,
              private accountingAccountRest: AccountingAccountRestService,
              private taxRateRest: TaxRateRestService) {
  }

  initDialogView(): any {
    return {
      details: expandObservable({
        migrationData: this.systemVarsRest.getAccountingMigrationData(),
        xeroAccounts: this.accountingAccountRest.findAll({ tmpCredentials: true }),
        xeroTaxRates: this.taxRateRest.findAll(true),
        accountClassDict: this.dictionaries.get('ACCOUNTS_CLASSES'),
      }).pipe(map$(({ migrationData, xeroAccounts, xeroTaxRates, accountClassDict }) => ({
        ...accMigrationDetailsFromDto(migrationData),
        xeroAccounts: accMigrationXeroAccountListFromDto(accountClassDict, xeroAccounts),
        xeroTaxRates,
        accountClassDict,
      }))),
    };
  }

  startSynchronization(details: AccMigrationDetails): Observable<void> {
    return this.systemVarsRest.startAccountingSync(accMigrationDetailsToDto(details));
  }
}
